export const payment = {
  button: 'Minta faktur',
  company_name: 'Nama Perusahaan',
  company_name_tooltip: 'Masukkan nama perusahaan yang akan menerbitkan faktur.',
  tooltip: 'Pilih mata uang di mana Anda ingin menerima faktur.',
  tooltip_email: 'Pilih atau masukkan alamat email tujuan pengiriman faktur.',
  legal_entities: 'Metode pembayaran ini hanya tersedia untuk badan hukum.',
  general: 'Dasar',
  success:
    'Kami telah menerima permintaan Anda untuk membuat akun. Spesialis keuangan akan segera menghubungi Anda.',
  asana_api_problems: 'Sebuah kesalahan telah terjadi. Coba lagi nanti.',
  finance_email: 'Email keuangan',
  email_rates: 'Email untuk tarif',
  email_optional: 'Email tambahan',
  widget: {
    balance: {
      title: 'Jumlah deposit {value}',
      button: 'Top up deposit'
    },
    modal: {
      title: 'Top up deposit',
      no_methods: 'Tidak ada metode pembayaran yang tersedia',
      form: {
        field: {
          amount: 'Jumlah'
        },
        submit: 'Bayar',
        minimal_amount: 'Minimum ',
        alert_minimum: 'Jumlah yang ditentukan kurang dari nilai minimum.',
        method_message: {
          comepay: '',
          fondy: '',
          invoice_request: '',
          tinkoff: 'Komisi 2,25% akan ditahan',
          webmoney: 'Pembayaran melalui WebMoney dikenakan tambahan 3,5%',
          yoomoney: 'Pembayaran melalui ЮMoney, dikenakan tambahan 5,5%',
          capitalist: '',
          paypal: 'Saat membayar melalui PayPal, komisi akan dipotong'
        }
      }
    }
  },
  errors: {
    check_user_phone: 'Menurut persyaratan Sistem Kartu Pembayaran Nasional untuk pembayaran dari kartu bank, Anda harus mencantumkan nomor telepon di <a href=".">profil</a> Anda'
  }
};
